import { render } from "./WalletExchangeInstrumentDetails.vue?vue&type=template&id=6e03611a&scoped=true"
import script from "./WalletExchangeInstrumentDetails.vue?vue&type=script&lang=js"
export * from "./WalletExchangeInstrumentDetails.vue?vue&type=script&lang=js"

import "./WalletExchangeInstrumentDetails.vue?vue&type=style&index=0&id=6e03611a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e03611a"]])

export default __exports__